module.exports = __webpack_public_path__ + "img/slots-logo-universal.5466c0d1.png";